/* Tabs */
if ($('.tabs').length) {
    $('.tabs li').click(function () {
        var $this = $(this);
        var $theTab = $(this).attr('id');
        console.log($theTab);
        if ($this.hasClass('active')) {
            //
        } else {
            $this.closest('.tabs_wrapper').find('ul.tabs li, .tabs_container .tab_content').removeClass('active');
            $('.tabs_container .tab_content[data-tab="' + $theTab + '"], ul.tabs li[id="' + $theTab + '"]').addClass('active');
        }
    });
}
/* Footer links */
$(document).on("click",".footer-top__column-title",function() {
    $(this).closest('.footer-top__column').toggleClass('ft-active');
});
/* Mobile menu */
$(document).on("click",".header-burger",function() {
    $('.app-mobile-menu').addClass('mobile-menu-active');
});
$(document).on("click",".close-mobile-menu",function() {
    $('.app-mobile-menu').removeClass('mobile-menu-active');
});
$(document).on("click",".app-mobile-menu .app-nav > ul > li > .site-nav__link  .nav-mobile-arrow",function (e) {
    e.preventDefault();
    $(this).closest("li").toggleClass("site-nav-active");
})
$(document).on("click",".app-mobile-menu .app-nav li .sub-megamenu .link-wrapper .sbprod .fst-title",function (e) {
    e.preventDefault();
    $(this).closest(".sbprod").toggleClass("site-nav-child-active");
})
$(document).on("click",".app-mobile-menu .app-nav li .sub-megamenu .link-wrapper .sbprod .snd-title",function (e) {
    e.preventDefault();
    $(this).closest(".sbprod").toggleClass("site-nav-child-active");
})
/* Modals */
$('[open-modal]').on('click', function(){
    var id = $(this).attr('open-modal');
    $('.modal#'+id).addClass('active');
});
$('[close-modal]').on('click', function(){
    $(this).parents('.modal').removeClass('active');
});
$('.modal').on('click', function(e) {
    if(e.target !== this){return};
    $(this).removeClass('active');
});
/* Catalog */
$(".view-switcher").on("click",function (e) {
    $(".view-switcher").removeClass('view-active');
    let dataView = $(this).data("view");
    $(this).addClass('view-active');
    $(".grid-uniform").removeClass('grid-view list-view').addClass($(this).data('view'));
})